var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchAds = function SvgSearchAds(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.662 17.637c-.225.18-4.21 2.489-4.21 7.621 0 5.937 5.07 8.037 5.222 8.089-.024.128-.806 2.876-2.673 5.676-1.665 2.465-3.404 4.925-6.05 4.925s-3.327-1.58-6.38-1.58c-2.977 0-4.035 1.632-6.455 1.632s-4.109-2.28-6.05-5.08C9.816 35.63 8 30.523 8 25.673c0-7.777 4.918-11.901 9.758-11.901 2.571 0 4.715 1.736 6.33 1.736 1.537 0 3.933-1.84 6.859-1.84 1.109 0 5.093.104 7.715 3.968Zm-9.104-7.26c1.21-1.477 2.066-3.525 2.066-5.573A3.95 3.95 0 0 0 31.55 4c-1.969.076-4.31 1.348-5.723 3.032-1.109 1.296-2.144 3.345-2.144 5.42 0 .313.05.625.074.725.125.024.327.052.53.052 1.766 0 3.987-1.216 5.271-2.852Z",
    fill: "#221F20"
  })));
};
export default SvgSearchAds;